import request from '../helper/request'

// ================= 合作伙伴接口 =================

// 获取合作伙伴列表（分页）
export function getPartnersList(params) {
    return request({
      url: '/api/getPartnerList/',
      method: 'post',
      data: params
    })
  }

// 新增合作伙伴（上传 logo）
export function addPartner(formData) {
  return request({
    url: '/api/addPartner/',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' } // 上传文件必需
  })
}

// 修改合作伙伴（上传新 logo 可选）
export function updatePartner(formData) {
  return request({
    url: '/api/updatePartner/',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 删除合作伙伴
export function deletePartner(params) {
  return request({
    url: '/api/deletePartner/',
    method: 'post',
    data: params
  })
}
